/* HB — portant : boucle infinie (téléphone et ordinateur).
   Boucle : défile en continu vers la gauche, chaque vêtement qui sort à gauche revient à droite.
   Arrêt au toucher / survol, reprise 3 s après. Téléphone + ordinateur (si tout ne tient pas à l'écran). */
(function () {
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    var list = root.querySelector('[data-hbr-items]');
    if (!list || list.dataset.auto) return; list.dataset.auto = '1';
    var canHover = matchMedia('(hover: hover)').matches, loop = true; // boucle infinie partout (mettre !canHover pour revenir à l'aller-retour sur ordinateur)
    var pos = 0, last = 0, paused = false, touching = false, visible = true, resumeT = null, centerEl = null, SPEED = 0.065; // px/ms ≈ 65 px/s
    function items() { return list.querySelectorAll('.hbr__item'); }
    function gap() { var g = parseFloat(getComputedStyle(list).columnGap); return isNaN(g) ? 4 : g; }
    function overflow() { return list.scrollWidth - list.clientWidth > 8; }
    function setX(x) { list.style.scrollBehavior = 'auto'; list.scrollLeft = x; }
    // Fait passer le premier vêtement à la fin (ou le dernier au début) sans que l'œil ne voie de saut
    function toEnd() { var f = items()[0]; if (!f) return 0; var w = f.offsetWidth + gap(); list.appendChild(f); pos -= w; setX(pos); return w; }
    function toStart() { var a = items(), l = a[a.length - 1]; if (!l) return 0; var w = l.offsetWidth + gap(); list.insertBefore(l, a[0]); pos += w; setX(pos); return w; }
    function recycle() {
      if (!overflow() || items().length < 3) return;
      var lr = list.getBoundingClientRect(), f = items()[0];
      if (f && f.getBoundingClientRect().right < lr.left) toEnd();
      else if (list.scrollLeft >= list.scrollWidth - list.clientWidth - 2) toEnd();
      if (list.scrollLeft <= 2) toStart();
    }
    // Grand écran : si tous les cintres tiennent à l'écran, on en accroche une copie à la suite pour que la boucle puisse tourner
    function fill() {
      var orig = [].filter.call(items(), function (x) { return !x.dataset.clone; }), guard = 0;
      if (orig.length < 2) return;
      while (list.scrollWidth - list.clientWidth < Math.max(320, list.clientWidth * 0.35) && guard < 4) {
        orig.forEach(function (o) {
          var c = o.cloneNode(true); c.dataset.clone = '1'; c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; c.classList.remove('is-front');
          c.addEventListener('click', function (e) { e.preventDefault(); o.click(); });
          c.addEventListener('mouseenter', function () { list.querySelectorAll('.hbr__item.is-front').forEach(function (x) { x.classList.remove('is-front'); }); c.classList.add('is-front'); });
          list.appendChild(c);
        });
        guard++;
      }
    }
    function pause(ms) { paused = true; clearTimeout(resumeT); if (ms) resumeT = setTimeout(function () { pos = list.scrollLeft; paused = false; }, ms); }
    // Sur téléphone, la pièce qui passe au centre pivote de face
    function center() {
      if (canHover) return;
      var m = list.getBoundingClientRect(), cx = m.left + m.width / 2, best = null, d = 1e9;
      items().forEach(function (b) { var r = b.getBoundingClientRect(), x = Math.abs(r.left + r.width / 2 - cx); if (x < d) { d = x; best = b; } });
      if (best && best !== centerEl) { centerEl = best; list.querySelectorAll('.hbr__item.is-front').forEach(function (x) { if (x !== best) x.classList.remove('is-front'); }); best.classList.add('is-front'); }
    }
    function tick(t) {
      var dt = last ? Math.min(t - last, 50) : 0; last = t;
      if (!reduced && !paused && visible && !document.hidden && !root.classList.contains('is-open') && overflow()) {
        if (loop) { pos += dt * SPEED; setX(pos); recycle(); center(); }
        else {
          var max = list.scrollWidth - list.clientWidth; pos += dt * SPEED;
          if (pos >= max) {
            pos = max; setX(pos); pause();
            // ordinateur : arrivé au bout, petite pause puis retour en douceur au début
            setTimeout(function () { list.style.scrollBehavior = ''; list.scrollTo({ left: 0, behavior: 'smooth' }); setTimeout(function () { pos = 0; paused = false; }, 1200); }, 1000);
          } else setX(pos);
        }
      }
      requestAnimationFrame(tick);
    }
    // Défilement au doigt : la boucle marche aussi dans les deux sens
    var rq = false;
    list.addEventListener('scroll', function () { if (!loop || !paused || rq) return; rq = true; setTimeout(function () { rq = false; pos = list.scrollLeft; recycle(); pos = list.scrollLeft; }, 80); }, { passive: true });
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { list.addEventListener(ev, function () { pause(); }, { passive: true }); });
    ['touchend', 'pointerup'].forEach(function (ev) { list.addEventListener(ev, function () { pause(3000); }, { passive: true }); });
    if (canHover) { list.addEventListener('mouseenter', function () { pause(); }); list.addEventListener('mouseleave', function () { pause(1500); }); }
    root.querySelectorAll('[data-hbr-sprev],[data-hbr-snext]').forEach(function (b) { b.addEventListener('click', function () { pause(4000); if (loop) setTimeout(function () { pos = list.scrollLeft; recycle(); }, 700); }); });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-hbr-close]')) pause(2500); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) pos = list.scrollLeft; }, { threshold: 0.2 }).observe(list);
    // Téléphone : défilement au pouce ralenti (le portant suit le doigt moins vite et s'arrête plus tôt quand on lâche)
    if (!canHover) {
      var DRAG = 0.55, FRICTION = 0.9, MAXV = 0.9; // DRAG : part du mouvement du doigt ; MAXV : élan max (px/ms) ; FRICTION : freinage
      var sx = 0, sy = 0, lx = 0, lt = 0, v = 0, horiz = null, mom = 0;
      list.style.touchAction = 'pan-y';
      list.addEventListener('touchstart', function (e) { var t = e.touches[0]; mom++; horiz = null; sx = lx = t.clientX; sy = t.clientY; lt = performance.now(); v = 0; }, { passive: true });
      list.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        if (horiz === null && (Math.abs(t.clientX - sx) > 6 || Math.abs(t.clientY - sy) > 6)) horiz = Math.abs(t.clientX - sx) > Math.abs(t.clientY - sy);
        if (!horiz) return;
        e.preventDefault();
        var now = performance.now(), step = (t.clientX - lx) * DRAG, dt = Math.max(now - lt, 1);
        setX(list.scrollLeft - step); v = 0.7 * v + 0.3 * (step / dt); lx = t.clientX; lt = now; center();
      }, { passive: false });
      list.addEventListener('touchend', function () {
        if (!horiz) return; var id = ++mom; v = Math.max(-MAXV, Math.min(MAXV, v));
        (function glide() {
          if (id !== mom || Math.abs(v) < 0.02) { recycle(); pos = list.scrollLeft; return; }
          setX(list.scrollLeft - v * 16); v *= FRICTION; recycle(); center(); requestAnimationFrame(glide);
        })();
      }, { passive: true });
    }
    // Démarrage : on place un vêtement « avant » le premier pour pouvoir aussi revenir en arrière au doigt
    setTimeout(function () { if (loop) fill(); if (loop && overflow() && items().length >= 3) { pos = list.scrollLeft; toStart(); } pos = list.scrollLeft; requestAnimationFrame(tick); }, 1000);
  }
  function boot() { document.querySelectorAll('[data-hbr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
